import React from 'react';
import { Row, Form ,Col} from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import FormInput from '../form/FormInput';
import FormSelect from '../form/FormSelect';
import { useAuth } from '../../context/AuthContext';
const StepRoleDetails = ({ control, errors, lookupOptions, projectList }) => {

      const { user } = useAuth();
    // const isAdmin = user?.roleCode === '100';
        const isAdmin = user?.roleCode == 100 || !!localStorage.getItem('adminToken');


    return (
    
    <div className="animate-fade-in">
        <div className="form-section-title">Basic Information</div>
        <Row>
            <Col md={3}><FormSelect name="project_name" label="Project *" control={control} errors={errors} options={projectList} isRequired /></Col>
            <Col md={3}><FormSelect name="audition_type" label="Audition Type *" control={control} errors={errors} options={lookupOptions.audition_type} isMulti isRequired /></Col>
            <Col md={3}><FormInput name="role_name" label="Role Name *" control={control} errors={errors} isRequired /></Col>
            <Col md={3}><FormSelect name="role_category" label="Category *" control={control} errors={errors} options={lookupOptions.role_category} isMulti isRequired /></Col>
        </Row>
        <Row>
            <Col md={3}><FormSelect name="gender" label="Gender *" control={control} errors={errors} options={lookupOptions.gender} isMulti isRequired /></Col>
            {/* <Col md={3}><FormSelect name="status" label="Status *" control={control} errors={errors} options={lookupOptions.status} isRequired /></Col> */}
            {isAdmin && (<Col md={3}><FormSelect name="status" label="Status *" control={control} errors={errors} options={lookupOptions.status} isRequired /></Col> )}
        </Row>
        
        <div className="form-section-title">Talent & Physical Requirements</div>
        <Row>
            <Col md={3}><FormSelect name="talent" label="Talent *" control={control} errors={errors} options={lookupOptions.talent} isMulti isRequired /></Col>
            <Col md={3}><FormSelect name="language" label="Language" control={control} errors={errors} options={lookupOptions.language} isMulti /></Col>
            <Col md={3}><FormSelect name="nationality" label="Nationality" control={control} errors={errors} options={lookupOptions.nationality} isMulti /></Col>
            <Col md={3}><FormSelect name="age_year" label="Age" control={control} errors={errors} options={lookupOptions.age_year} isMulti /></Col>
        </Row>
        <Row>
            <Col md={3}><FormSelect name="hair_color" label="Hair Color" control={control} errors={errors} options={lookupOptions.hair_color} isMulti /></Col>
            <Col md={3}><FormSelect name="body_type" label="Body Type" control={control} errors={errors} options={lookupOptions.body_type} isMulti /></Col>
            <Col md={3}><FormSelect name="height_ft" label="Height" control={control} errors={errors} options={lookupOptions.height_ft} isMulti /></Col>
            <Col md={3}><FormSelect name="eye_color" label="Eye Color" control={control} errors={errors} options={lookupOptions.eye_color} isMulti /></Col>
        </Row>
        <Row>
            <Col md={3}><FormSelect name="special_category" label="Special Category" control={control} errors={errors} options={lookupOptions.special_category}  isMulti={false} /></Col>
            <Col md={3}><FormSelect name="waist_size" label="Waist Size" control={control} errors={errors} options={lookupOptions.waist_size} isMulti /></Col>
            <Col md={3}><FormSelect name="chest_size" label="Chest Size" control={control} errors={errors} options={lookupOptions.chest_size} isMulti /></Col>
            <Col md={3}><FormSelect name="dialect" label="Dialect" control={control} errors={errors} options={lookupOptions.dialect} isMulti /></Col>
        </Row>
        <Row>
            <Col md={3}><FormSelect name="experience_level" label="Experience Level" control={control} errors={errors} options={lookupOptions.experience_level} isMulti /></Col>
            <Col md={3}><FormSelect name="skin_color" label="Skin Color" control={control} errors={errors} options={lookupOptions.skin_color} isMulti /></Col>
            <Col md={3}><FormSelect name="driving_type" label="Driving License Type" control={control} errors={errors} options={lookupOptions.driving_type} isMulti /></Col>
            <Col md={3}><FormSelect name="people_appearance_list" label="People Appearance List" control={control} errors={errors} options={lookupOptions.people_appearance_list} isMulti /></Col>
        </Row>
        <Row>
            <Col md={3}><FormSelect name="sports_type" label="Sports Type" control={control} errors={errors} options={lookupOptions.sports_type} isMulti /></Col>
            <Col md={3}><FormSelect name="esports_type" label="Sports/E-Sports Type" control={control} errors={errors} options={lookupOptions.esports_type} isMulti /></Col>
        </Row>
        
        <Form.Group className="mb-4">
            <Form.Label className="form-label">Description</Form.Label>
            <Controller name="role_description" control={control} render={({ field }) => <Form.Control as="textarea" rows={3} {...field} className="custom-form-input shadow-none" />} />
        </Form.Group>
        <FormInput name="role_required_count" label="# Total Seats" type="number" control={control} errors={errors} hidden />
    </div>
);
};

export default StepRoleDetails;